import { useState, useEffect } from 'react';
import api from '../../../services/api';

// Task 36 — GET v1/talent-dashboard?processId[eq] (Task 24 sözleşmesi:
// NineBoxDistribution/PoolStatus/SuccessionCoverage/IdpCompletion/
// FlightRiskDistribution). processId opsiyonel — verilmezse BE en son
// "completed" NineBoxProcess'e düşer (bkz. TalentDashboardDataAccess.
// ResolveProcessIdAsync); süreç seçici temizlenince (GenericSelect
// onChange(null)) otomatik çözüme geri döner. usePrdPerformanceDashboardApi
// (Task 32) İLE AYNI desen — bağımsız kopya (repo konvansiyonu).
const emptyDashboard = {
  nineBoxDistribution: null,
  poolStatus: null,
  successionCoverage: null,
  idpCompletion: null,
  flightRiskDistribution: null,
};

export default function useTalentDashboardApi() {
  const [processId, setProcessId] = useState(null);
  const [data, setData] = useState(emptyDashboard);
  const [loading, setLoading] = useState(true);
  // TD-23 — `status` ZATEN okunuyordu ama başarısızlık boş panoya düşüp SESSİZ kalıyordu:
  // beş kart da "veri yok" gösteriyor, kullanıcı okumanın başarısız olduğunu bilmiyordu.
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    const params = processId ? { 'processId[eq]': processId } : {};
    api.get('/v1/talent-dashboard', { params })
      .then((res) => {
        if (cancelled) return;
        const ok = res.data?.status === true;
        setLoadFailed(!ok);
        setData(ok ? res.data.data : emptyDashboard);
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [processId]);

  return {
    processId, setProcessId, data, loading, loadFailed,
  };
}
